import React from "react";
import { makeStyles, Paper, Table, TableBody, TableCell, TableHead, TableRow, TableSortLabel } from "@material-ui/core";
import { Delete, EditIcon, SortIcon } from "../../LeftNav/SvgIcons";
import { TooltipDescription } from "../../../../components/common/Modal/AssetsModals";
import TagsOverlay from "../ConversationsRevamp/TagsOverlay";

const useStyles = makeStyles(theme => ({
    gridTopNav: {
        padding: "10px 0 10px 0",
        display: "flex",
        justifyContent: "flex-start",
        gap: "10px",
        alignItems: "center",
        // minHeight: "23px",
    },
    selectedItems: {
        textAlign: "right",
        color: "#8D99A5",
        fontSize: "14px",
        fontWeight: "400",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
    },
    deleteItems: {
        display: "flex",
        alignItems: "center",
    },
    gridHeaderInner: {
        color: "#A9B2BC",
        fontSize: "12px",
        fontWeight: "700",
        paddingTop: "12px",
        paddingBottom: "9px",
    },
    gridHeader: {
        background: "#E5F2FF",
        borderRadius: "6px",
    },
    gridHeaderRow: {
        borderRadius: "6px",
    },
    checkBoxFont: {
        fontSize: "22px",
    },
    gridBodyInner: {
        color: "#464E5F",
        fontSize: "14px",
        fontWeight: "400",
        paddingTop: "4px",
        paddingBottom: "4px",
    },
    businessGroup: {
        background: "#E5F2FF",
        color: "#8254E3",
    },
    pendingButtons: {
        color: "#FFAD4E",
        backgroundColor: "rgba(255, 173, 78, 0.25)",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "rgba(255, 173, 78, 0.25)",
        },
    },
    launchedButtons: {
        color: "#FFAD4E",
        backgroundColor: "rgba(255, 173, 78, 0.25)",
        boxShadow: "none",
        "&:hover": {
            backgroundColor: "rgba(255, 173, 78, 0.25)",
        },
    },
    inUseYes: {
        color: "#18BC6D",
    },
    inUseNo: {
        color: "#E06145",
    },
    lastLoginWrapper: {
        width: "110px",
    },
}));

export default function ContactTypesList({
    contactTypesData,
    onDeleteContactType,
    onEditContactType,
    order,
    onOrderBy }) {

    const classes = useStyles();

    return (
        <Paper>
            <Table>
                <TableHead className={classes.gridHeader}>
                    <TableRow className={classes.gridHeaderRow}>
                        <TableCell className={classes.gridHeaderInner}>
                            Name
                            <TableSortLabel
                                active={order.orderByKey === "NameSingularInternal"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "NameSingularInternal",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Contact Area
                            <TableSortLabel
                                active={order.orderByKey === "ContactAreaName"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "ContactAreaName",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            OFish Role
                            <TableSortLabel
                                active={order.orderByKey === "OFishRoleName"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "OFishRoleName",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Contacts Count
                            <TableSortLabel
                                active={order.orderByKey === "ContactCounts"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "ContactCounts",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={classes.gridHeaderInner}>
                            Status
                            <TableSortLabel
                                active={order.orderByKey === "Status"}
                                direction={order.orderVal === 1 ? "asc" : "desc"}
                                onClick={() =>
                                    onOrderBy({
                                        orderByKey: "Status",
                                        orderVal: order.orderVal === 0 ? 1 : 0,
                                    })
                                }
                                IconComponent={SortIcon}
                                className='sortIcon'
                            />
                        </TableCell>
                        <TableCell className={(classes.gridHeaderInner, "quickLinkWrapper quickLinkHeader")}>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {contactTypesData.map(item => {
                        return (
                            <TableRow key={item.id} className='gridBodyRow endUserRow'>
                                <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}>
                                    {/* {item.nameSingularInternal} */}
                                    <TooltipDescription
                                        title={<TagsOverlay
                                            title="Contact Type Name"
                                            noChipText="No Message Found"
                                            tags={[]}
                                            text={item.nameSingularInternal ?? ""}
                                        />}
                                        placement={"bottom"}>
                                        <span>
                                            {item.nameSingularInternal ? item.nameSingularInternal.length <= 20 ? item.nameSingularInternal : `${item.nameSingularInternal.substring(0, 19)}...` : "--"}
                                        </span>
                                    </TooltipDescription>
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}>
                                    {item.contactAreaName}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}>
                                    {item.oFishRoleName}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}
                                    style={{textAlign: "center"}}
                                >
                                    {item.contactCounts}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "capitalize-first")}>
                                    {item.status === 1 ? "In Use" : "Not In Use"}
                                </TableCell>
                                <TableCell
                                    className={(classes.gridBodyInner, "quickLinkWrapper")}>
                                    <div className='gridActions'>
                                        <span></span>
                                        <span onClick={() => onDeleteContactType(item)}>
                                            <Delete />
                                        </span>
                                        <span onClick={() => onEditContactType(item)} style={{width: "auto"}}>
                                            <EditIcon />
                                        </span>
                                    </div>
                                </TableCell>
                            </TableRow>
                        )
                    })}
                    {(contactTypesData.length === 0) && (
                        <TableRow key='0' className='gridBodyRow'>
                            <TableCell
                                colSpan='7'
                                className={classes.gridBodyInner}
                                style={{ textAlign: "center" }}>
                                <span className='emptyGridText'>
                                Uh Oh! You have not created any contact types yet!
                                </span>
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </Paper>
    );
};
